import { render, staticRenderFns } from "./couponBind.vue?vue&type=template&id=9c21996a&scoped=true"
import script from "./couponBind.vue?vue&type=script&lang=js"
export * from "./couponBind.vue?vue&type=script&lang=js"
import style0 from "./couponBind.vue?vue&type=style&index=0&id=9c21996a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c21996a",
  null
  
)

export default component.exports